import parse from 'html-react-parser';

const Html = ({ html }) => {
    return <>{parse(html || '')}</>;
};

export default Html;
